import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { LanguageBanner } from "@/components/LanguageBanner";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import { trackVisit } from "@/lib/api";
import Home from "@/pages/Home";
import AnswerPage from "@/pages/AnswerPage";
import AdminPage from "@/pages/AdminPage";
import LearnIndexPage from "@/pages/LearnIndexPage";
import LearnPage from "@/pages/LearnPage";
import WellnessPage from "@/pages/WellnessPage";
import ToolsPage from "@/pages/ToolsPage";
import ToolDetailPage from "@/pages/ToolDetailPage";
import VerifyPage from "@/pages/VerifyPage";
import SharePage from "@/pages/SharePage";
import DoctorRespondPage from "@/pages/DoctorRespondPage";
import EmbedToolPage from "@/pages/EmbedToolPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { PrivacyPage, TermsPage, DisclaimerPage } from "@/pages/Legal";

const Layout = () => (
  <div className="min-h-screen flex flex-col bg-[#FAFAF7]">
    <LanguageBanner />
    <Navbar />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <Toaster position="top-center" richColors />
  </div>
);

function App() {
  useEffect(() => {
    if (typeof navigator !== "undefined" && navigator.userAgent !== "ReactSnap") {
      trackVisit();
    }
  }, []);
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/doctor/respond/:id" element={<DoctorRespondPage />} />
          <Route path="/embed/tools/:slug" element={<EmbedToolPage />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/answer" element={<AnswerPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/library" element={<LearnIndexPage />} />
            <Route path="/wellness" element={<WellnessPage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/tools/:slug" element={<ToolDetailPage />} />
            <Route path="/verify/:certId" element={<VerifyPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
            <Route path="/s/:id" element={<SharePage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/:lang/library" element={<LearnIndexPage />} />
            <Route path="/:slug" element={<LearnPage />} />
            <Route path="/:lang/:slug" element={<LearnPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
